import * as yup from 'yup'
import { getRequiredSchema } from 'src/deps'

const teamComponents = Object.assign(
  getRequiredSchema({
    inputName: 'teamName',
    requiredType: 'teamName',
  }),
  getRequiredSchema({
    inputName: 'costCenter',
    requiredType: 'costCenter',
  })
)

export const schema = yup.object(teamComponents)
